import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { getPrintPreview } from './utils'
import {parseHtmlForReact} from './../helpers'

@observer
export default class StaticText extends Component {

	constructor(props){
		super(props)
	}

    getContent = () => {
        const {question, store} = this.props
        const {langcode} = store
        const {defaultLocale} = store.data.metadata
        let text = ''
        if (question.content.content) {
            text = question.content.content[langcode]
                ? question.content.content[langcode].text
                : question.content.content[defaultLocale]
                    ? question.content.content[defaultLocale].text
                    : ''
        }
        return store.replaceOptionMerge(text)
    }

    render() {
        const { store, question } = this.props
		return (
            <div>
                {getPrintPreview(question, store)}
                {parseHtmlForReact(this.getContent())}
            </div>
        )
    }
}
